import Layout from "../../components/Layout.tsx";
import { Field, FieldGroup, Label } from "../../components/Fieldset.tsx";
import { Input } from "../../components/Input.tsx";
import { StepProps } from "./AddNewConnection.tsx";
import { useNewConnectionContext } from "../../context/NewConnectionContext.tsx";
import { useConnectionData } from '../../hooks/data.ts';
import Spinner from "../../components/Spinner.tsx";

const ConnectionNameStep = ({ handleButtonBackClick, handleButtonNextClick, stepIndicator }: StepProps) => {
  const { newConnectionData, dispatch } = useNewConnectionContext();
  const { loading } = useConnectionData(newConnectionData.systemAuthorizationId);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: "UPDATE_FIELD", key: 'name', value: e.target.value });
  };

  const isUpdating = newConnectionData.id && newConnectionData.id > 0;

  return (
    <Layout
      title={isUpdating ? "Koppeling aanpassen" : "Nieuwe koppeling maken"}
      stepTitle="Koppelingsnaam"
      onButtonBackClick={loading ? undefined : handleButtonBackClick}
      onButtonNextClick={loading ? undefined : handleButtonNextClick}
      stepIndicator={stepIndicator}
    >
      {loading ? (
        <div className="flex justify-center items-center min-h-[200px]">
          <Spinner />
        </div>
      ) : (
        <FieldGroup>
          <Field className="items-baseline sm:grid sm:grid-cols-4">
            <Label>Naam koppeling</Label>
            <Input
              name="name"
              className="sm:col-span-3 max-w-lg"
              onChange={handleNameChange}
              value={newConnectionData.name}
              disabled={loading}
            />
          </Field>
        </FieldGroup>
      )}
    </Layout>
  );
};

export default ConnectionNameStep;
